<canvas [style.maxHeight.px]="maxHeight"
  baseChart
  *ngIf="chartData"
  [data]="chartData"
  [options]="_chartOptions"
  [type]="_chartType"
  [plugins]="_plugins"
  (chartHover)="chartHover.emit($event)"
  (chartClick)="chartClick.emit($event)"></canvas>